// src/utils/imageUrls.js
import { supabase } from "../pages/supabaseClient";

const BUCKET = "images";
const urlCache = new Map();

const isAbsolute = (p) => /^(https?:|blob:|data:)/i.test(p);

export function getImageUrl(path) {
  if (!path) return null;
  if (isAbsolute(path)) return path;
  let url = urlCache.get(path);
  if (!url) {
    url = supabase.storage.from(BUCKET).getPublicUrl(path).data.publicUrl;
    urlCache.set(path, url);
  }
  return url;
}

const NEW_FORMAT = /_v2\.jpg$/;

export function getThumbPath(path) {
  if (path && !isAbsolute(path) && NEW_FORMAT.test(path)) {
    return path.replace(/\.jpg$/, "_thumb.jpg");
  }
  return path;
}

export const getThumbUrl = (path) => getImageUrl(getThumbPath(path));

export const getAvatarUrl = getImageUrl;